import { useEffect } from 'react';

// Simple background-scroll lock. Necessary to prevent background scroll in Safari / iOS 17.
// TODO: Remove when Safari respects html/body overflow hidden (on toolbar minimized)

function useDisableScroll() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  useEffect(function () {
    var rootElement = document.querySelector('body');
    var scrollBarWidth = window.innerWidth - rootElement.clientWidth;
    if (enabled) {
      var scrollPosition = window.scrollY;
      rootElement.style.overflow = 'hidden';
      rootElement.style.position = 'fixed';
      rootElement.style.top = "-".concat(scrollPosition, "px");
      rootElement.style.width = '100%';
      rootElement.style.paddingRight = "".concat(scrollBarWidth, "px");
      return function () {
        rootElement.style.removeProperty('overflow');
        rootElement.style.removeProperty('position');
        rootElement.style.removeProperty('top');
        rootElement.style.removeProperty('width');
        rootElement.style.removeProperty('padding-right');
        window.scrollTo(0, scrollPosition);
      };
    }
    return undefined;
  }, [enabled]);
}

export { useDisableScroll as default };
//# sourceMappingURL=useDisableScroll.js.map
